export const SYSTEM_TYPES = {
  Message: 0,
  AssignTo: 1,
  MoveToClose: 2,
  MoveToPending: 3,
  MoveToUnAssign: 4,
  WaitingForResolution: 5,
  FirstTimeResponse: 6,
  ChangeTopic: 7,
  MoveToCase: 8,
  MoveToBot: 9,
  MoveToMyCase: 10,
  TicketUpdated: 11,
  Unsend: 12,
  AdminLeaveGroupMention: 13,
  IsSendSuccess: 14,
  Unknown: 99
};

export const SYSTEM_ROLES_NAME = {
  SUPERADMIN: "SUPERADMIN",
  SUPERVISOR: "SUPERVISOR",
  ADMIN: "ADMIN"
};

export const USER_TYPES = {
  User: "user",
  Admin: "admin",
  System: "system"
};

export const SOCIAL_TYPES = {
  All: 99,
  Line: 1,
  Web: 2,
  Mobile: 3,
  Facebook: 4,
  Instagram: 5,
  Whatsapp: 6
};
export const SOCIAL_TYPES_NAME = {
  All: "All",
  Line: "Line",
  Web: "Web",
  Mobile: "Mobile",
  Facebook: "Facebook",
  Instagram: "Instagram",
  Whatsapp: "Whatsapp"
};

export const MESSAGE_TYPES = {
  Text: 1,
  Audio: 12,
  Flex: 5,
  Image: 4,
  Order: 13,
  Voucher: 14,
  SurveyUrl: 98,
  File: 8
};

export const TYPES = {
  BusinessHour: 3
};
